import React, {useState, useEffect, useRef }from 'react'
import {hostUrl, tokenExpiredLoginAgain, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../../constants/global';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import {useNavigate, NavLink} from "react-router-dom";
import {shortNameUser, formatPostDate} from '../common/Helper';
import VerifyImg from '../../assets/images/Verify.svg';
import { callPageRenderTracking } from '../common/Helper';

import AnchorLink from 'react-anchor-link-smooth-scroll-v2';

import { Editor } from '@tinymce/tinymce-react';

function TopicDetail() {

    const editorRef = useRef(null);

    let { id } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    /****Get Data from storage*****/
    const topicBucketState =  useSelector(state => state.TopicBucket);
    var topicBucketStateBucket = topicBucketState.bucket.owner_question;
    if(topicBucketStateBucket){
        var fromStorage = topicBucketStateBucket.find(obj => obj.ID === id);
    }


    /*****Define Constants*****/
    const [useripaddress, setUserIpAddress] =  useState("");
    const [isActive, setActive] = useState("false");
    const [question, setQuestion] = useState(fromStorage ? fromStorage : "");
    const [replies, setReplies] = useState("");
    const [replycontent, setReplyContent] = useState("Comment");
    const [responsemessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);


    const AddClass = (e) => {
        var _target = e.target;
        var active_id = _target.getAttribute('data-id');
       setActive(active_id);
    };

    const RemoveClass = (e) => {
        var _target = e.target;
        var active_id = _target.getAttribute('data-id');
       setActive("false");
    };

    var loadingSection = <>
        <div class="topic-list loader-data">
        <div class="answers-info-image">AU</div>
        <div class="topic_name"></div>
        <div class="post-list-info"></div>
        <div class="topic_content"></div>
        <div class="topic_content"></div>
        </div>
        <div class="topic-list loader-data">
        <div class="answers-info-image">AU</div>
        <div class="topic_name"></div>
        <div class="post-list-info"></div>
        <div class="topic_content"></div>
        <div class="topic_content"></div>
        </div>
        <div class="topic-list loader-data">
        <div class="answers-info-image">AU</div>
        <div class="topic_name"></div>
        <div class="post-list-info"></div>
        <div class="topic_content"></div>
        <div class="topic_content"></div>
        </div>
    </>;

    //console.log(objectFound);

    useEffect(() => {

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = { callingaction: 'topic_detail', topic_id: id };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 

            if(actualData.status==='success'){

                var post_title_render = actualData.topic_data.question[0].post_title;
                callPageRenderTracking({page_title:post_title_render,page_link:window.location.href});

                // console.log(actualData);
                // console.log("testestest");

            /******set question and replies*****/
            setQuestion(actualData.topic_data.question[0]);
            setReplies(actualData.topic_data.replies);   
            
            }else if(actualData.status==='validationerror'){
                dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                //alert(tokenExpiredLoginAgain);
                navigate('/login/?message='+tokenExpiredLoginAgain);
            }
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });


        /*******add class on body*****/
        document.body.classList.add('white-bg-header');
        return () => {
            document.body.classList.remove('white-bg-header');
        }

    },[]);


    /**** question data****/
    const QuestionData = (data) => {

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

        var formatDate = formatPostDate(question.post_date);

        if(data.sectionflag==="onlyquestion"){
            return  <h1 className='topic-banner-title m-0'>{question.post_title}</h1>
        }

        if(data.sectionflag==="questionanswer"){
            return  <div className='comment-row'>
                        <div className='comment-header'>
                            <div className='post-list-info'>
                                <div className='info-col'><span className="material-icons-outlined">person</span> {question.post_anonymously === "1" ? "User"+question.post_author : question.author_name}</div>  
                                <div className="info-space">|</div>
                                <div className='info-col'><span className="material-icons-outlined"> calendar_month</span> {formatDate}</div>
                            </div>
                        </div>
                        <div className='comment-box'>
                            <div className="content" dangerouslySetInnerHTML={{__html: question.post_content}}></div>
                        </div>
                    </div> 
            }

    }

    /******replies loop*****/
    const RepliesData = () => {

        return replies.map((element) => {

            var user_short_name = shortNameUser(element.author_name);

            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

            var formatDate = formatPostDate(element.post_date);

            return <div className={isActive===element.ID ? "answers-box more" : "answers-box"} key={element.ID}>
                    
                    <div className="answers-info">
                        <div className='answers-info-image'>
                            {element.post_anonymously === "1" ? "U" : user_short_name}
                            {element.author_name=="CIIS Support" && <img className='verified-img' src={VerifyImg}/>}
                        </div>
                        <div className='answers-name'>{element.post_anonymously === "1" ? "User"+storageDataAuthLogin.authid : element.author_name}</div>  
                        <div className='post-list-info'><div className='info-col'><span className="material-icons-outlined"> calendar_month </span> {formatDate}</div></div>
                    </div>
                    <div className='answers-content'>
                        
                        <div className="content" dangerouslySetInnerHTML={{__html: element.post_content}}></div>

                    </div>
                    {element.post_content.length >= 200 && 
                        <>
                        <button type='button' data-id={element.ID} className='read-more' onClick={(e) => AddClass(e)}>Read More</button>
                        <button type='button' data-id={element.ID} className='read-less' onClick={(e) => RemoveClass(e)}>Read Less</button>
                        </>
                    }
                </div>
          
            }
        )
    }

    /**********Submit Reply***********/
    const submitReply  = (e) => {
        e.preventDefault();

        var topicreplycontent = editorRef.current.getContent();

        if(topicreplycontent){

            /*******get the user ip address*********/
            fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708').then(response => {
            return response.json();
            }).then((res) => {
                if(res.IPv4){
                    setUserIpAddress(res.IPv4);
                }            
            });

        
            var topic_title = question.post_title;
            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageData = authlogin ? JSON.parse(authlogin) : "";
            
            var token = 'Bearer '+storageData.token;
            var username = storageData.user_email;

            setLoading(true);

            const data = { callingaction: 'topic_reply', topic_title: topic_title, topic_id: id, content : topicreplycontent, userip: useripaddress  };

            const requestOptions = {
                    method: 'POST',
                    //mode:'cors',
                    headers: { 'Content-Type': 'application/json', 
                    'POST' : '/resource HTTP/1.1',
                    'Authorization': token,
                    'Host' : hostUrl,
                    'username' : username,
                    body: JSON.stringify(data),
                    }
                };

            fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
            .then((response) => response.json())
            .then(function(actualData){ 
                
                setResponseMessage({status:"success",message:"We have send the reply for approval"});
                setReplyContent("");
                setLoading(false);

            
            }).catch(rejected => {
                //setResponseMessage({status:"error",message:highTrafficInnerPages});
            });
        }


    }

    /*********set on state accroding to fields************/
    const handleInputChange = (replycontent) => {
        // if(e.target.name==="reply-content"){
        //     setReplyContent(e.target.value);
        // }
    }

    console.log(replies.length);
    console.log("replies length");

  return (
    <>
    <div className="fullpage-box knowledge-fullpage-box topic-content-box p-l-0 p-r-0">

    {/*********Question Section only*********/} 
        <div className='topic-banner topic-detail-banner'>
                <div className="topic-container">

                <NavLink className="back-btn" to="/topic-list"><span className="material-icons-outlined">arrow_back </span>Back to Topics</NavLink>

                {question && <> 
                    {/*********back to topic**********/}
                    <QuestionData sectionflag="onlyquestion"/> 
                    </> 
                }
                </div>
        </div>
   

    <div className="topic-container topic-detail-container">

    {question === "" && loadingSection}

    {question && <>
        

        {/*********Question Content*********/}
        <QuestionData sectionflag="questionanswer"/>
        
        {/*********Replies*********/}
        <div className="answers-row">
            <div className='answers-title'>
                {replies.length} Answers 
                <AnchorLink href='#comment_form' className='add-comment'><span className="material-icons-outlined">add</span> Add Comment</AnchorLink>
            </div>

            {replies ? <RepliesData /> : loadingSection}
        </div>

        {/*********Comment Form*********/}
        <div className='comment-form' id='comment_form'>
            
            <form onSubmit={submitReply}>

                <div className="comment-field">
                    {/* <textarea value={replycontent} name="reply-content" className='reply-content' placeholder="Comment" onChange={(e) => handleInputChange(e)} required /> */}
                    
                    <Editor
                    apiKey="r5ixlsvtvg9v4rx95avemaeyvniv0ujxz8na67bi6kydcsx0"
                    onInit={(evt, editor) => editorRef.current = editor}
                    initialValue={replycontent}
                    init={{
                        height: 400,
                        menubar: false,
                        branding: false,
                        toolbar: 'undo redo | formatselect | ' +
                        'bold italic | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                       />

                </div>

                
                    <button type="submit" className="submit-reply">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>}Submit</button>
            


                {responsemessage && <span className="response-message">{responsemessage.message}</span>}


            </form>
        </div>

    </>}

</div>
</div>

    </>
  )
}

export default TopicDetail